import React, { FC } from 'react';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import { useFormFieldsContext } from '../../../context';
import {
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsUploadSection
} from '../components';

import {
  COLLECT_TEXT_FIELD,
  FREE_TILES_LAYOUT_OPTIONS,
  MAIN_OFFER_BACKGROUND_COLOR,
  MAIN_OFFER_UPLOAD_FIELDS,
  ONE_PLUS_MANY_UPLOAD_FIELDS,
  SUB_OFFER_BG_FIELDS,
  SUB_OFFER_UPLOAD_FIELDS
} from './BuyOneGetManyOfferDesignFormFields.consts';

const findFreeTilesLayoutOption = (currentValue: number | undefined) => {
  const stringValue = currentValue === undefined ? '2' : String(currentValue);
  return (
    FREE_TILES_LAYOUT_OPTIONS.find((option) => option.value === stringValue) ??
    FREE_TILES_LAYOUT_OPTIONS[1]
  );
};

export const BuyOneGetManyOfferDesignFormFields: FC =
  (): React.ReactElement => {
    const { values, setFieldValue } = useFormFieldsContext();

    return (
      <React.Fragment>
        <FormFieldsSection
          heading="1+Many"
          description="Customize the 1+Many offer to fit your store theme."
        >
          <FormFieldsIdentitySection
            extraFields={[COLLECT_TEXT_FIELD]}
            spacing="none"
          />
          <div className="mt-5">
            <InputSelectDropdown
              label="Free Tiles Layout"
              isRequired
              options={FREE_TILES_LAYOUT_OPTIONS}
              defaultSelected={findFreeTilesLayoutOption(
                values.freeTilesLayout
              )}
              onOptionChange={(value) =>
                setFieldValue('freeTilesLayout', Number(value))
              }
            />
          </div>

          <FormFieldsUploadSection fields={ONE_PLUS_MANY_UPLOAD_FIELDS} />
        </FormFieldsSection>

        <FormFieldsSection
          heading="Main Offer Design"
          showSeparator
          headingBottomMargin
        >
          <FormFieldsGradientRow
            fields={[MAIN_OFFER_BACKGROUND_COLOR]}
            spacing="sm"
          />
          <FormFieldsUploadSection fields={MAIN_OFFER_UPLOAD_FIELDS} />
        </FormFieldsSection>

        <FormFieldsSection
          heading="Sub Offer Design"
          spacing="xl"
          headingBottomMargin
        >
          <FormFieldsGradientRow fields={SUB_OFFER_BG_FIELDS} spacing="sm" />
          <FormFieldsUploadSection fields={SUB_OFFER_UPLOAD_FIELDS} />
        </FormFieldsSection>
      </React.Fragment>
    );
  };
